import { render, staticRenderFns } from "./BeritaAdd.vue?vue&type=template&id=877b75a6"
import script from "./BeritaAdd.vue?vue&type=script&lang=js"
export * from "./BeritaAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports